import mixpanel from "common/mixpanel";
import pageData from "common/page-data";

// Track all Site.Homepage hits
mixpanel.track(
  "Site.Homepage",
  Object.assign({
    homepageVariant: "v2",
    partner: pageData.get("partner")
  })
);
